'use client'

import { createAuthClient } from 'better-auth/react'
import { genericOAuthClient } from 'better-auth/client/plugins'

/**
 * Client better-auth. Senza `baseURL` usa l'origin corrente (funziona sia in
 * dev `legapuglia-dev.sportnix.me` sia in prod `legapuglia.sportnix.me`).
 */
export const authClient = createAuthClient({
  plugins: [genericOAuthClient()],
})
